import { render, staticRenderFns } from "./RubroVentaListSelect.vue?vue&type=template&id=765eacba&"
import script from "./RubroVentaListSelect.vue?vue&type=script&lang=js&"
export * from "./RubroVentaListSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
